export default __webpack_public_path__ + "static/media/pic.16c0828d.jpg";